export const toKebabCase = (str: string) =>
  str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();

export const toCamelCase = (str: string) => str.toLowerCase().replace(/(-\w)/g, m => m[1].toUpperCase());
